'use client';
import dynamic from 'next/dynamic';
import type { Props as ApexChartProps } from 'react-apexcharts';
import { deepMerge } from '@witmetrics/utils/objects';
import Box from '@/components/Box';
import type { PointSelection } from './types';
import { classes, mergeChartOptions, styles } from './utils';

// NOTE: react-apexcharts requires access to `window`, which throws off next.js compiling
const ApexChart = dynamic(() => import('react-apexcharts'), {
  ssr: false,
});

export interface ChartProps extends ApexChartProps {
  onMount?: () => void;
  onSelect?: (selection: PointSelection) => void;
}

export default function Chart({
  options = {},
  series,
  onMount,
  onSelect,
  ...props
}: ChartProps) {
  const events = {
    chart: {
      events: {
        mounted: () => onMount?.(),
        dataPointSelection: (
          e: MouseEvent,
          _: any,
          selection: PointSelection
        ) => {
          onSelect?.(selection);
        },
      },
    },
  };

  return (
    <Box sx={styles.wrapper} className={classes.wrapper}>
      <ApexChart
        // @ts-ignore
        options={deepMerge(mergeChartOptions(options), events)}
        series={series}
        {...props}
      />
    </Box>
  );
}
